function throwIfInvalidArrayFieldIndex(arr, index) {
  const indexes = Array.isArray(index) ? index : [index];
  for (const i of indexes) {
    if (i < 0 || arr.length <= i) {
      throw new Error(`The specified index (${index}) doesn't exists on the Array Field`);
    }
  }
}
export {
  throwIfInvalidArrayFieldIndex
};
//# sourceMappingURL=throwIfInvalidArrayFieldIndex.js.map
